import './main.less';
import React from 'react';

const Logo = () => (
	<p className="rocket-logo font-proxima-nova-bold">
		<span>
			Rocket<span className="rocket-logo-profit">Profit</span>
		</span>
	</p>
);

export default Logo;


// WEBPACK FOOTER //
// ./frontend/cabinets/apps/rocket/modules/sidebar/logo/main.js